var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.css }, [
    _c("div", { staticClass: "subheading" }, [
      _c("div", [
        _c(
          "svg",
          {
            attrs: {
              width: "40px",
              height: "2px",
              viewBox: "0 0 40 2",
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
            },
          },
          [
            _c(
              "g",
              {
                attrs: {
                  stroke: "none",
                  "stroke-width": "2",
                  fill: "none",
                  "fill-rule": "evenodd",
                },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      transform: "translate(-20.000000, -916.000000)",
                      fill: "#fff",
                    },
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          transform: "translate(20.000000, 904.000000)",
                        },
                      },
                      [
                        _c("g", [
                          _c("rect", {
                            attrs: {
                              x: "0",
                              y: "12",
                              width: "40",
                              height: "2",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "h6 wysiwyg",
        domProps: { innerHTML: _vm._s(_vm.item.subheading) },
      }),
    ]),
    _vm._v(" "),
    _vm.index == 0
      ? _c("h1", {
          staticClass: "hero-homepage__heading wysiwyg",
          domProps: { innerHTML: _vm._s(_vm.item.heading) },
        })
      : _c("h2", {
          staticClass: "hero-homepage__heading wysiwyg",
          domProps: { innerHTML: _vm._s(_vm.item.heading) },
        }),
    _vm._v(" "),
    _vm.hasLink
      ? _c(
          "a",
          {
            staticClass: "btn--hero",
            class: _vm.ctaLinkClass,
            attrs: {
              href: _vm.link.url,
              target: _vm.getTarget,
              rel: _vm.getRel,
              title: _vm.item.cta_seo_title,
            },
          },
          [_vm._v(_vm._s(_vm.link.title))]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }